module.exports = __webpack_public_path__ + "static/media/card_8.8406fc06.png";